import * as Yup from 'yup';

import { LABELS } from '../../keys';

export interface BrebFormValues {
  breBKey: string;
  bankName: string;
  accountOwnerName: string;
}

export const getBrebInitialValues = (): BrebFormValues => ({
  breBKey: '',
  bankName: '',
  accountOwnerName: '',
});

export const getBrebValidationSchema = () =>
  Yup.object({
    breBKey: Yup.string().trim().required(LABELS.ERRORS.REQUIRED_FIELD[1]),
    bankName: Yup.string().trim().required(LABELS.ERRORS.REQUIRED_FIELD[1]),
    accountOwnerName: Yup.string().trim().required(LABELS.ERRORS.REQUIRED_FIELD[1]),
  });
